export const groupHeaderStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'end',
		pl: 2,
		pr: 1,
		pt: 1,
		pb: 0
	},
	clearButton: {
		fontWeight: 700,
		height: 24,
		mb: 1
	}
};
